import { FormatNumber } from 'utils/helpers';

import { FOCO_SOBRE_AZUL } from 'utils/foco';

interface FeedHeroProps {
  /** Quem é da Rede Joga Junto não vê Realizações Destaque. */
  rede: boolean;
  /** Total de funcis participantes; omitido enquanto carrega. */
  participantes?: number;
}

export default function FeedHero({ rede, participantes }: FeedHeroProps) {
  return (
    <section
      aria-labelledby="titulo-feed-hero"
      className="flex flex-wrap items-center gap-6 rounded-2xl bg-brand-blue px-[30px] py-[26px] text-brand-white"
    >
      <div className="min-w-[320px] flex-1">
        <h2
          id="titulo-feed-hero"
          tabIndex={0}
          className={`m-0 mb-2 font-display text-[20px] font-bold leading-[normal] text-brand-yellow ${FOCO_SOBRE_AZUL}`}
        >
          Feed da Transparência Joga Junto BB
        </h2>
        <p tabIndex={0} className={`m-0 text-[14px] leading-[1.6] ${FOCO_SOBRE_AZUL}`}>
          Aqui você pode visualizar os reconhecimentos recebidos{rede ? '' : ' e as Realizações Destaque'} dos seus colegas!
        </p>
      </div>
      {typeof participantes === 'number' && (
        // SPEC_DEVIATION: véu a 4% (design: 12%) para o texto de 11px passar 4,5:1.
        <div tabIndex={0} className={`flex items-center gap-2.5 rounded-xl bg-white/[0.04] px-[18px] py-3.5 ${FOCO_SOBRE_AZUL}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--brand-yellow)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <p className="m-0">
            <span className="block font-display text-[22px] font-extrabold leading-none text-brand-yellow">
              {FormatNumber(participantes, false)}
            </span>
            <span className="block text-[11px]">funcis participando</span>
          </p>
        </div>
      )}
    </section>
  );
}
